import { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import styles from "../styles/Header.module.scss";
import { useTranslation } from "react-i18next";
import Arrow from "../imgs/arrow.svg";
// import Logo from "../imgs/logo.png";
import Logo from "../imgs/logo.svg";
import { Drawer } from "@mui/material";
import { setHeaderDrawer } from "../redux/slices/rootSlice.js";
import { useAppDispatch, useAppSelector } from "../redux/store.js";
import Menu from "../imgs/menu.svg";
import Cross from "../imgs/cross.svg";
import secureLocalStorage from "react-secure-storage";
import Select, { components } from "react-select";
import LanguageButton from "./LanguageButton.jsx";

export default function Header() {
  const { t, i18n } = useTranslation();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const dispatch = useAppDispatch();
  const [language, setLanguage] = useState(false);
  const languageRef = useRef(null);
  const headerDrawer = useAppSelector((state) => state.root.headerDrawer);
  const [aboutUsDrawer, setAboutUsDrawer] = useState(false);
  const [menuDrawer, setMenuDrawer] = useState(false);
  const [drawerLines, setDrawerLines] = useState([false, false]);
  const navigate = useNavigate();
  // const [desktopDrawer, setDesktopDrawer] = useState(true);
  // const languages = ["en", "de", "pl", "fr", "it", "cz"];
  const languages = [
    {
      value: "en",
      label: "English",
      flag: "https://flagcdn.com/w320/us.png",
    },
    {
      value: "pl",
      label: "Polski",
      flag: "https://flagcdn.com/w320/pl.png",
    },
    {
      value: "de",
      label: "Deutsch",
      flag: "https://flagcdn.com/w320/de.png",
    },
    {
      value: "fr",
      label: "Français",
      flag: "https://flagcdn.com/w320/fr.png",
    },
    {
      value: "cz",
      label: "Czech",
      flag: "https://flagcdn.com/w320/cz.png",
    },
    {
      value: "it",
      label: "Italian",
      flag: "https://flagcdn.com/w320/it.png",
    },
    {
      value: "es",
      label: "Español",
      flag: "https://flagcdn.com/w320/es.png",
    },
  ];

  useEffect(() => {
    const storedLang = secureLocalStorage.getItem("lang");
    if (!storedLang) {
      changeLanguage("en");
    } else {
      i18n.changeLanguage(storedLang);
    }
  }, []);

  function changeLanguage(e) {
    i18n.changeLanguage(e);
    secureLocalStorage.setItem("lang", e);
  }
  const handleSetLanguage = () => {
    setLanguage((prev) => !prev);
  };
  const handleSetHeaderDrawer = () => {
    dispatch(setHeaderDrawer(!headerDrawer));
  };

  const handleSetAboutUsDrawer = () => {
    setAboutUsDrawer(!aboutUsDrawer);
  };

  const handleSetMenuDrawer = () => {
    setMenuDrawer(!menuDrawer);
  };

  useEffect(() => {
    if (headerDrawer || aboutUsDrawer) {
      setMenuDrawer(false);
    }
  }, [headerDrawer, aboutUsDrawer]);

  useEffect(() => {
    if (headerDrawer || aboutUsDrawer || menuDrawer) {
      document.body.style.position = "fixed";
    } else {
      document.body.style.position = "";
    }
  }, [headerDrawer, aboutUsDrawer, menuDrawer]);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const closeAllDrawers = () => {
    setAboutUsDrawer(false);
    setMenuDrawer(false);
    dispatch(setHeaderDrawer(false));
  };

  const DropdownIndicator = ({ children, ...props }) => (
    <components.DropdownIndicator {...props}>
      <div className={styles.single_value_container}>
        <div className={styles.custom_icon}>
          <svg
            width={"1.7vh"}
            height={"1.6vh"}
            viewBox="0 0 17 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.5003 6L8.83366 10L4.16699 6"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        {children}
      </div>
    </components.DropdownIndicator>
  );

  const Control = ({ children, ...props }) => {
    return (
      <components.Control {...props}>
        <div className={styles.country_start}>
          <span
            className={
              children[0].props.selectProps.value ? styles.flag : styles.icon
            }
          >
            {children[0].props.selectProps.value ? (
              <img src={children[0].props.selectProps.value.flag} alt="flag" />
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={"1.7vh"}
                height={"1.6vh"}
                viewBox="0 0 17 16"
                fill="none"
              >
                <g clipPath="url(#clip0_420_48527)">
                  <ellipse
                    cx="8.84733"
                    cy="6.66667"
                    rx="4.66667"
                    ry="4.66667"
                    stroke="#51525C"
                  />
                  <path
                    d="M3.51465 11.0415C4.77357 12.4481 6.60307 13.3333 8.63931 13.3333C12.4365 13.3333 15.5146 10.2551 15.5146 6.45798C15.5146 4.42173 14.6294 2.59223 13.2229 1.33331"
                    stroke="#51525C"
                    strokeLinecap="round"
                  />
                  <path
                    d="M5.51465 3.0351C5.90477 3.40352 6.70842 4.41053 6.80205 5.49122C6.88957 6.50137 7.5325 7.32219 8.51465 7.33331C8.89209 7.33758 9.27382 7.05481 9.27285 6.66337C9.27255 6.54233 9.25328 6.41857 9.22313 6.30471C9.1812 6.14634 9.17748 5.96415 9.26465 5.77777C9.56959 5.12576 10.1693 4.95062 10.6446 4.59652C10.8554 4.43948 11.0476 4.2738 11.1324 4.14036C11.3665 3.77194 11.6006 3.0351 11.4835 2.66669"
                    stroke="#51525C"
                  />
                  <path
                    d="M13.5146 7.33331C13.3683 7.74711 13.2646 8.83331 11.6116 8.85055C11.6116 8.85055 10.1478 8.85055 9.70863 9.67814C9.35731 10.3402 9.56225 11.0575 9.70863 11.3333"
                    stroke="#51525C"
                  />
                  <path
                    d="M8.84766 14.6666V13.3333"
                    stroke="#51525C"
                    strokeLinecap="round"
                  />
                  <path
                    d="M8.84798 14.6667H7.51465"
                    stroke="#51525C"
                    strokeLinecap="round"
                  />
                  <path
                    d="M10.181 14.6667H8.84766"
                    stroke="#51525C"
                    strokeLinecap="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_420_48527">
                    <rect
                      width={16}
                      height={16}
                      fill="white"
                      transform="translate(0.847656)"
                    />
                  </clipPath>
                </defs>
              </svg>
            )}
          </span>
          <div className={styles.country}>{children}</div>
        </div>
      </components.Control>
    );
  };
  const CustomOptionCountry = (props) => {
    const { innerProps, innerRef } = props;
    return (
      <div
        ref={innerRef}
        {...innerProps}
        className={
          props.isSelected
            ? styles.custom_option_selected
            : styles.custom_option
        }
      >
        <div className={styles.option_country}>
          <img
            src={props.data.flag}
            alt="flag"
            style={{ borderRadius: "50%" }}
          />
          {props.data.label}
        </div>
      </div>
    );
  };

  const colourStylesCountry = {
    control: (styles) => ({
      ...styles,
      backgroundColor: "transparent",
      width: "100%",
      minHeight: "48px",
      color: "#121926",
      border: "1px solid #26272B",
      boxShadow: "none",
      borderRadius: "32px",
      fontSize: "14px",
      ".custom_select__indicators": {
        ".custom_select__indicator": {
          padding: "0.4vh !important",
        },
      },
    }),
    menu: (styles) => ({
      ...styles,
      background: "transparent",
      border: "none",
      boxShadow: "none",
      outlined: "none",
    }),
    placeholder: (styles) => ({
      ...styles,
      fontSize: "14px",
    }),
    menuList: (styles) => ({
      ...styles,
      outlined: "none",
      background: "#1D1D20",
      color: "#fff",
      borderRadius: "24px",
      padding: "0.4vh 0.4vh",
      zIndex: "1",
      "::-webkit-scrollbar": {
        width: "4px",
        height: "0px",
      },
      "::-webkit-scrollbar-track": {
        background: "#1D1D20",
      },
      "::-webkit-scrollbar-thumb": {
        background: "#3F3F46",
        zIndex: "0",
      },
      "::-webkit-scrollbar-thumb:hover": {
        background: "#3F3F46",
      },
    }),
    multiValue: (styles) => ({
      ...styles,
      backgroundColor: "transparent",
      color: "#121926",
      padding: 0,
    }),
    multiValueLabel: (styles) => ({
      ...styles,
      color: "#121926",
      padding: 0,
    }),
    multiValueRemove: (styles) => ({
      ...styles,
      display: "none",
    }),
    input: (styles) => ({
      ...styles,
      backgroundColor: "transparent",
      color: "#121926",
      fontSize: "14px",
    }),
    option: (styles, { data, isFocused, isSelected }) => ({
      ...styles,
      backgroundColor: isFocused || isSelected ? "#161C24" : undefined,
      color: data.color ? data.color : "#FCFCFC",
      fontSize: "1.4vh",
      lineHeight: "1.6vh",
      padding: "12px 4px 12px 12px",
      borderRadius: "32px",
      ":hover": {
        backgroundColor: "#2C2D30",
        color: "#FCFCFC",
      },
    }),
    singleValue: (baseStyles) => ({
      ...baseStyles,
      fontWeight: "400",
      fontFamily: "'Inter', sans-serif",
      color: "#FCFCFC",
      display: "flex",
      alignItems: "center",
      fontSize: "14px",
    }),
    value: (baseStyles) => ({
      ...baseStyles,
      fontSize: "14px",
    }),
  };
  return (
    <div className={styles.header}>
        <Link to="/" className={styles.left_side}>
          <img src={Logo} alt="logo" width="40px" height="40px" />
          {/* <span>Synergy Assets</span> */}
        </Link>
    
        <div className={styles.right_side}>
          {/* <Link to="/accounts" className={styles.link}>
            {t("Account types")}
          </Link>
          <div onClick={handleSetHeaderDrawer} className={styles.link}>
            {t("Tools")} <img src={Arrow} alt="arrow" />
          </div>
          <Link to="/bonuses" className={styles.link}>
            {t("Bonuses")}
          </Link>
          <div onClick={handleSetAboutUsDrawer} className={styles.link}>
            {t("About us")} <img src={Arrow} alt="arrow" />
          </div> */}
          <LanguageButton />
          <div onClick={handleSetHeaderDrawer} className={styles.menuButton}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                d="M13.3335 4L2.66683 4"
                stroke="white"
                stroke-width="2"
                stroke-linecap="square"
              />
              <path
                d="M13.3335 8L2.66683 8"
                stroke="white"
                stroke-width="2"
                stroke-linecap="square"
              />
              <path
                d="M13.3335 12L2.66683 12"
                stroke="white"
                stroke-width="2"
                stroke-linecap="square"
              />
            </svg>
            {t("Menu")}
          </div>
          {/* <Link to="/login" className={styles.login_button}>
            {t("Account")}
          </Link> */}
          {/* <Link to="/login" className={styles.login_button}>
            {t("Login")}
          </Link>
          <Link to="/register" className={styles.register_button}>
            {t("Register")}
          </Link> */}
        </div>
    
      <Drawer
        anchor={windowWidth > 600 ? "right" : "top"}
        open={headerDrawer}
        onClose={handleSetHeaderDrawer}
        sx={{
          "& .MuiDrawer-paper": {
            margin: "24px",
            boxShadow: "none",
            borderRadius: "24px",
            border: "1px solid rgba(255, 255, 255, 0.08)",
            background: "rgba(17, 17, 17, 0.48)",
            backdropFilter: "blur(32px)",
            height: "calc(100vh - 48px)",
          },
        }}
      >
        <div className={styles.drawer}>
          <div className={styles.main}>
            <div className={styles.top}>
              <span>{t("Menu")}</span>
              <svg
                onClick={handleSetHeaderDrawer}
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
              >
                <path
                  d="M11.8856 4.17676L4.34315 11.7192"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="square"
                />
                <path
                  d="M11.6569 11.8242L4.11439 4.28175"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="square"
                />
              </svg>
            </div>
            <div className={styles.middle}>
              <div onClick={() => {
                      navigate("/accounts");
                      setDrawerLines([false, false]);
                      handleSetHeaderDrawer();
                    }} className={styles.title}>{t("Account types")}</div>
              <div
                onClick={() => setDrawerLines([!drawerLines[0], false])}
                className={drawerLines[0] ? styles.title_active : styles.title}
              >
                {t("Tools")}
                {drawerLines[0] ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <path
                      d="M12.6667 10L8.00002 6L3.33335 10"
                      stroke="#FCFCFC"
                      stroke-width="2"
                      stroke-linecap="square"
                    />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <path
                      d="M12.6667 6L8.00002 10L3.33335 6"
                      stroke="white"
                      stroke-opacity="0.72"
                      stroke-width="2"
                      stroke-linecap="square"
                    />
                  </svg>
                )}
              </div>
              {drawerLines[0] && (
                <div className={styles.subtitle}>
                  <span
                    onClick={() => {
                      navigate("/tools/forexHeatMap");
                      setDrawerLines([false, false]);
                      handleSetHeaderDrawer();
                    }}
                  >
                    {t("Forex Heat-map")}
                  </span>
                  <span
                    onClick={() => {
                      navigate("/tools/stockHeatMap");
                      setDrawerLines([false, false]);
                      handleSetHeaderDrawer();
                    }}
                  >
                    {t("Heat-map of the stock")}
                  </span>
                  <span
                    onClick={() => {
                      navigate("/tools/etfHeatMap");
                      setDrawerLines([false, false]);
                      handleSetHeaderDrawer();
                    }}
                  >
                    {t("ETF Heat-map")}
                  </span>
                  <span
                    onClick={() => {
                      navigate("/tools/CryptoHeatMap");
                      setDrawerLines([false, false]);
                      handleSetHeaderDrawer();
                    }}
                  >
                    {t("Crypto Coin Heat-map")}
                  </span>
                  <span
                    onClick={() => {
                      navigate("/tools/cryptocurrencyMarket");
                      setDrawerLines([false, false]);
                      handleSetHeaderDrawer();
                    }}
                  >
                    {t("Cryptocurrency Market")}
                  </span>
                  <span
                    onClick={() => {
                      navigate("/tools/economicCalendar");
                      setDrawerLines([false, false]);
                      handleSetHeaderDrawer();
                    }}
                  >
                    {t("Economic Calendar")}
                  </span>
                  <span
                    onClick={() => {
                      navigate("/tools/topStories");
                      setDrawerLines([false, false]);
                      handleSetHeaderDrawer();
                    }}
                  >
                    {t("Top Stories")}
                  </span>
                </div>
              )}
              <div onClick={() => {
                      navigate("/bonuses");
                      setDrawerLines([false, false]);
                      handleSetHeaderDrawer();
                    }} className={styles.title}>{t("Bonuses")}</div>
              <div
                onClick={() => setDrawerLines([false, !drawerLines[1]])}
                className={drawerLines[1] ? styles.title_active : styles.title}
              >
                {t("About us")}
                {drawerLines[1] ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <path
                      d="M12.6667 10L8.00002 6L3.33335 10"
                      stroke="#FCFCFC"
                      stroke-width="2"
                      stroke-linecap="square"
                    />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <path
                      d="M12.6667 6L8.00002 10L3.33335 6"
                      stroke="white"
                      stroke-opacity="0.72"
                      stroke-width="2"
                      stroke-linecap="square"
                    />
                  </svg>
                )}
              </div>
              {drawerLines[1] && (
                <div className={styles.subtitle}>
                  <span
                    onClick={() => {
                      navigate("/affiliate");
                      setDrawerLines([false, false]);
                      handleSetHeaderDrawer();
                    }}
                  >
                    {t("Affiliate program")}
                  </span>
                  <span
                    onClick={() => {
                      navigate("/about");
                      setDrawerLines([false, false]);
                      handleSetHeaderDrawer();
                    }}
                  >
                    {t("About company")}
                  </span>
                  <span
                    onClick={() => {
                      navigate("/privacy");
                      setDrawerLines([false, false]);
                      handleSetHeaderDrawer();
                    }}
                  >
                    {t("Privacy policy")}
                  </span>
                </div>
              )}
              {/* <div className={styles.title}>{t("Contact us")}</div> */}
            </div>
          </div>
          <div className={styles.bottom}>
            <div onClick={() => {
                      navigate("/login");
                      setDrawerLines([false, false]);
                      handleSetHeaderDrawer();
                    }} className={styles.button}>
              {t("Login")}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="17"
                height="16"
                viewBox="0 0 17 16"
                fill="none"
              >
                <path
                  d="M4.5 4L12.5 12M12.5 12L12.5 6M12.5 12L6.5 12"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="square"
                />
              </svg>
            </div>
            <div onClick={() => {
                      navigate("/register");
                      setDrawerLines([false, false]);
                      handleSetHeaderDrawer();
                    }} className={styles.button}>
              {t("Registration")}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="17"
                height="16"
                viewBox="0 0 17 16"
                fill="none"
              >
                <path
                  d="M4.5 4L12.5 12M12.5 12L12.5 6M12.5 12L6.5 12"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="square"
                />
              </svg>
            </div>
          </div>
        </div>
      </Drawer>
    </div>
  );
}
